const getAccessTokenFromUrl = (url: Location) => {
  const fragments = url.hash.substring(1).split(`&`)
  const token = fragments[0].split(`=`)[1]
  // const token = `32a1eb7e-a919-47f2-bace-395f737a6791`
  console.log(`DEV: first 3 from token`, token?.substring(0, 3))
  return token
}

export default getAccessTokenFromUrl
